import React from "react";
import {
  updateStoredSearch,

} from "../../store/Newsearchform/Newsearchform";
import { useSelector } from "react-redux";
import { authuser } from "../../store/Authentication/AuthSlice";

const CUSTOMER_ROLES = ["customer", "customer_admin"];

// Decorative "plane drifting through clouds" illustration. Purely presentational —
// the animations are defined in App.css and disabled under prefers-reduced-motion.
const CLOUD_SHADOW =
  "drop-shadow(0 0 .6px #E8B54A) drop-shadow(0 2px 3px rgba(232,163,23,.2))";

const SmallCloud = ({ x, y, scale, animation }) => (
  <g style={{ animation, filter: CLOUD_SHADOW }}>
    <g transform={`translate(${x} ${y}) scale(${scale})`} fill="url(#rfCloudSm)">
      <rect x="0" y="14" width="80" height="18" rx="9" />
      <circle cx="28" cy="16" r="13" />
      <circle cx="48" cy="12" r="15" />
    </g>
  </g>
);

const CloudBank = ({ circles, fill, animation }) => (
  <g fill={fill} style={{ animation }}>
    {circles.map(([cx, cy, r], i) => (
      <circle key={i} cx={cx} cy={cy} r={r} />
    ))}
  </g>
);

function NoRatesIllustration() {
  return (
    <svg
      viewBox="0 0 360 220"
      className="rateFailureIllo block w-[360px] sm:w-[260px] max-w-full h-auto overflow-hidden"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <radialGradient id="rfSun" cx=".5" cy=".5" r=".5">
          <stop offset="0" stopColor="#FFF1D6" />
          <stop offset=".75" stopColor="#FFF7E8" />
          <stop offset="1" stopColor="#FFF9EC" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="rfCloudSm" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#FBF1DD" />
        </linearGradient>
        <linearGradient id="rfCloudBack" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFF6E2" />
          <stop offset="1" stopColor="#F6E2B8" />
        </linearGradient>
        <linearGradient id="rfCloudFront" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#FBF1DD" />
        </linearGradient>
        <linearGradient id="rfFadeV" x1="0" y1="0" x2="0" y2="1">
          <stop offset=".86" stopColor="#fff" />
          <stop offset="1" stopColor="#000" />
        </linearGradient>
        <linearGradient id="rfFadeH" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#000" />
          <stop offset=".08" stopColor="#fff" />
          <stop offset=".92" stopColor="#fff" />
          <stop offset="1" stopColor="#000" />
        </linearGradient>
        <mask
          id="rfFadeMask"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="360"
          height="220"
        >
          <rect width="360" height="220" fill="url(#rfFadeV)" />
          <rect
            width="360"
            height="220"
            fill="url(#rfFadeH)"
            style={{ mixBlendMode: "multiply" }}
          />
        </mask>
      </defs>

      {/* warm glow behind the plane */}
      <circle
        cx="190"
        cy="110"
        r="95"
        fill="url(#rfSun)"
        style={{
          animation: "airGlow 4s ease-in-out infinite",
          transformBox: "fill-box",
          transformOrigin: "center",
        }}
      />

      <SmallCloud
        x={62}
        y={62}
        scale={0.75}
        animation="airCloudA 8s ease-in-out infinite"
      />
      <SmallCloud
        x={268}
        y={112}
        scale={0.6}
        animation="airCloudB 9s ease-in-out infinite"
      />

      {/* plane + speed lines */}
      <g
        style={{
          animation: "airBob 3.2s ease-in-out infinite",
          transformBox: "fill-box",
          transformOrigin: "center",
        }}
      >
        <g
          stroke="#F8C76A"
          strokeLinecap="round"
          fill="none"
          style={{ animation: "airLines 1.8s ease-in-out infinite" }}
        >
          <path
            d="M150 128 C122 140 96 150 66 158"
            strokeWidth="4"
            opacity=".9"
          />
          <path
            d="M160 140 C136 154 112 164 86 172"
            strokeWidth="3"
            opacity=".7"
          />
        </g>
        <g transform="translate(140 66) scale(3.2)">
          <path
            d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"
            fill="#FFF7E8"
            stroke="#E8A317"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>

      {/* cloud floor */}
      <g
        mask="url(#rfFadeMask)"
        style={{
          filter:
            "drop-shadow(0 -1px 0 #F8D99A) drop-shadow(0 2px 4px rgba(232,163,23,.22))",
        }}
      >
        <CloudBank
          circles={[
            [20, 200, 44],
            [80, 210, 36],
            [128, 196, 26],
            [176, 206, 32],
            [232, 196, 30],
            [290, 204, 34],
            [346, 192, 42],
          ]}
          fill="url(#rfCloudBack)"
          animation="airCloudB 10s ease-in-out infinite"
        />
        <CloudBank
          circles={[
            [-6, 222, 42],
            [56, 232, 38],
            [118, 226, 30],
            [182, 222, 38],
            [246, 230, 34],
            [308, 222, 36],
            [368, 218, 40],
          ]}
          fill="url(#rfCloudFront)"
          animation="airCloudA 7s ease-in-out infinite"
        />
      </g>
    </svg>
  );
}

function FailureSearchRate() {
  const state = useSelector(updateStoredSearch);
    // const queryiddata=useSelector(updatequeryid);

    // console.log(state, "state");

    const { newsearchformdata, rqueryid } = state?.payload?.newsearchform;
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles || null;
  // KAM/admin get a plain "no rates found" — the "your KAM has been informed"
  // copy below is written for customers and doesn't make sense when the
  // person looking at this page IS the KAM.
  const isKamOrAdmin = !CUSTOMER_ROLES.includes(userroles);
  return (
    <div className="oopsPage flex flex-col items-center justify-center text-center px-6 py-16 sm:px-4 sm:py-10">
      <figure className="m-0 flex justify-center w-full">
        <NoRatesIllustration />
      </figure>

      <h3 className="mt-6 sm:mt-4 text-xl sm:text-lg font-bold text-secondary leading-snug">
        {isKamOrAdmin ? "No rates found" : "We can't provide rates at this moment"}
      </h3>

    {  !isKamOrAdmin && newsearchformdata?.requestType==="1" &&  (<p className="mt-4 max-w-[560px] text-sm sm:text-xs leading-[1.65] text-graytext">
          But your KAM has been informed about this query, and they will be
          sharing a quotation very soon. Stay tuned to the notification center***
          for the quote
        </p>)}
    </div>
  );
}

export default FailureSearchRate;
